/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filterpresetreset2Inputs */

const en_filterpresetreset2 = /** @type {(inputs: Filterpresetreset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const de_filterpresetreset2 = /** @type {(inputs: Filterpresetreset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Filterpresetreset2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filterpresetreset2 = /** @type {((inputs?: Filterpresetreset2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filterpresetreset2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filterpresetreset2(inputs)
	return de_filterpresetreset2(inputs)
});
export { filterpresetreset2 as "filterPresetReset" }